var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBarrier(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 5.00037V11.4343M3 22.0004V19.2194M21 5.00037V11.4343M21 22.0004V19.2194M3 11.4343V19.2194M3 11.4343H9.75V19.2194H3M21 11.4343V19.2194M21 11.4343H14.25V19.2194H21",
    stroke: "#883A95",
    strokeWidth: 2,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.0086 7.00037H20.0005H20.9C20.9552 7.00037 21 6.95559 21 6.90037V2.10181C21 2.04665 20.9553 2.0019 20.9002 2.00181L20.0005 2.00037H4.0086L3.09991 2.00136C3.04472 2.00142 3.00002 2.04618 3.00002 2.10136L3 6.90037C3 6.95559 3.04477 7.00037 3.1 7.00037H4.0086Z",
    fill: "#883A95",
    stroke: "#883A95",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarrier);
export default __webpack_public_path__ + "static/media/barrier.839aa9049cffde3b9d5678b8c39bf229.svg";
export { ForwardRef as ReactComponent };